import {
  Workflow as OctopusWorkflow,
  WorkflowFieldOptionsResponse,
} from '../models/workflow';
import { ConfigurationMapper } from './configuration';
import {
  EditableListItem,
  WorkflowFieldOption,
  WorkflowListItem,
  WorkflowProperty,
} from '../../../models';
import { Mapper } from '../../../mappers';
import { FieldOption } from '../models/field-options';

export class WorkflowFieldOptionMapper extends ConfigurationMapper<
  WorkflowFieldOptionsResponse,
  WorkflowFieldOption
> {
  from(source: WorkflowFieldOptionsResponse): WorkflowFieldOption {
    const workflow = source.Workflow?.FieldOptions;

    return {
      readAccess: workflow?.SecAccess?.Read?.map(this.mapSecurityAccess) ?? [],
      fullAccess: workflow?.SecAccess?.Write?.map(this.mapSecurityAccess) ?? [],
      category: workflow?.Category?.map(this.mapFieldOption) ?? [],
      entity: workflow?.EntityType?.map(this.mapFieldOption) ?? [],
    };
  }
}

export class WorkflowPropertyMapper extends Mapper<
  OctopusWorkflow[],
  WorkflowProperty[]
> {
  from(source: OctopusWorkflow[]): WorkflowProperty[] {
    return source.map(
      (item) =>
        ({
          key: item.Key,
          name: item.Name,
          description: item.Description,
          canRead: item.SecStatus?.CanRead ?? false,
          canCreate: item.SecStatus?.CanCreate ?? false,
          canUpdate: item.SecStatus?.CanUpdate ?? false,
          canDelete: item.SecStatus?.CanDelete ?? false,
          isSequential: item.IsSequential ?? true,
          hasStages: item.HasStages ?? false,
          category: item.Category?.[0]?.DisplayValue ?? '',
          entity:
            item.EntityType && typeof item.EntityType === 'object'
              ? (item.EntityType.DisplayValue ?? '')
              : '',
          entityType:
            item.EntityType &&
            typeof item.EntityType === 'object' &&
            item.EntityType.Key != null
              ? item.EntityType.Key
              : undefined,
          readAccess: item.SecAccess?.Read[0]?.DisplayValue ?? '',
          fullAccess: item.SecAccess?.Write[0]?.DisplayValue ?? '',
        }) as WorkflowProperty,
    );
  }

  mapToListItem(source: OctopusWorkflow[]): WorkflowListItem[] {
    return source.map((item) => ({
      id: item.Key ?? '',
      name: item.Name ?? '',
      hasStages: item.HasStages ?? false,
      isSequential: item.IsSequential ?? true,
      canDelete: item.SecStatus?.CanDelete ?? false,
      entityType:
        item.EntityType &&
        typeof item.EntityType === 'object' &&
        item.EntityType.Key != null
          ? item.EntityType.Key
          : undefined,
    }));
  }

  mapCategoryForEdit(source: FieldOption): EditableListItem<string> {
    return {
      id: source.Key ?? '',
      name: source.DisplayValue,
      isActive: !source.InActive,
      isEditing: false,
      canDelete: true,
      canEdit: true,
    };
  }
}
